import { useState } from 'react';

import PropTypes from 'prop-types';

import { Menu } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import MenuItemComponent from './MenuItemComponent';

import { ButtonLink, StatusButton } from '../Button';

const DropDownMenu = ({
  title,
  color,
  isFullWidth,
  isButton,
  items = [],
  disabled,
  CustomAnchor,
  ...rest
}) => {
  const { t } = useTransl();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    event?.preventDefault();
    event?.stopPropagation();
    setAnchorEl(null);
  };

  const filteredItems = items?.filter(({ show }) => show !== false);

  const anchor = isButton ? (
    <StatusButton
      variant="contained"
      disableElevation
      disableRipple
      onClick={handleClick}
      sx={(theme) => ({
        backgroundColor: theme.palette.grey[500],
        height: '4rem',
      })}
      style={color && { backgroundColor: color }}
      disabled={disabled}
      aria-label={t('ariaLabel.anchorButton')}
      fullWidth={isFullWidth}
    >
      {title}
    </StatusButton>
  ) : (
    <ButtonLink
      onClick={handleClick}
      color="textPrimary"
      aria-label={t('ariaLabel.anchorButton')}
    >
      {title}
    </ButtonLink>
  );

  return (
    <>
      {CustomAnchor ? (
        <CustomAnchor
          onClick={handleClick}
          aria-label={t('ariaLabel.anchorButton')}
        />
      ) : (
        anchor
      )}
      <Menu
        elevation={0}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: (theme) => ({
            border: '0.1rem solid #CFCFCF',
            borderRadius: '1rem',
            backgroundColor: theme.palette.common.white,
          }),
        }}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        {...rest}
      >
        {filteredItems.map(({ label, onClick, disabled, color }, i) => (
          <MenuItemComponent
            key={i}
            label={label}
            onClick={onClick}
            handleClose={handleClose}
            disabled={disabled}
            color={color}
          />
        ))}
      </Menu>
    </>
  );
};

DropDownMenu.defaultProps = {
  color: null,
  isFullWidth: false,
  isButton: false,
  items: [],
  CustomAnchor: null,
  title: null,
};

DropDownMenu.propTypes = {
  title: PropTypes.node,
  color: PropTypes.string,
  isFullWidth: PropTypes.bool,
  isButton: PropTypes.bool,
  items: PropTypes.instanceOf(Array),
  CustomAnchor: PropTypes.func,
  disabled: PropTypes.bool,
};

export default DropDownMenu;
